
import { useState } from "react";
import styles from "../HealthChat.module.css";

/* ─── SVG Icons ─────────────────────────────────────────────────────────── */
const CalendarIcon = ({ size = 52 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const VideoIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x="1" y="5" width="15" height="14" rx="2" />
  </svg>
);

const LocationIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 1 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const TIME_SLOTS = [
  "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
];
const isToday = (dateStr) => {
  if (!dateStr) return false;

  const selected = new Date(dateStr);
  const today = new Date();

  return (
    selected.getFullYear() === today.getFullYear() &&
    selected.getMonth() === today.getMonth() &&
    selected.getDate() === today.getDate()
  );
};
const isPastSlot = (slot) => {
  const now = new Date();

  const [time, modifier] = slot.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) hours += 12;
  if (modifier === "AM" && hours === 12) hours = 0;

  const slotTime = new Date();
  slotTime.setHours(hours, minutes, 0, 0);

  return slotTime <= now;
};
const LANGS_OPTIONS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिंदी" },
  { code: "te", label: "తెలుగు" },
];

/* ─── Copy ───────────────────────────────────────────────────────────────── */
const COPY = {
  en: {
    title: "Book An Appointment",
    subtitle: "Would you like to speak with a women's health specialist?",
    typeLabel: "Select Visit Mode",
    online: "Online",
    inPerson: "In-Person",
    dateLabel: "Preferred Date",
    timeLabel: "Preferred Time",
    langLabel: "Language Preference",
    doctorTitle: "Doctor",
    doctorName: "Dr. Neha Sharma",
    doctorRole: "Women's Health Specialist",
    doctorExp: "15+ years experience",
    maybeLater: "Maybe Later",
    bookBtn: "Book An Appointment",
  },
  hi: {
    title: "अपॉइंटमेंट बुक करें",
    subtitle: "क्या आप महिला स्वास्थ्य विशेषज्ञ से बात करना चाहेंगी?",
    typeLabel: "विज़िट मोड चुनें",
    online: "ऑनलाइन",
    inPerson: "व्यक्तिगत रूप से",
    dateLabel: "पसंदीदा तारीख",
    timeLabel: "पसंदीदा समय",
    langLabel: "भाषा वरीयता",
    doctorTitle: "डॉक्टर",
    doctorName: "Dr. Neha Sharma",
    doctorRole: "महिला स्वास्थ्य विशेषज्ञ",
    doctorExp: "15+ वर्ष का अनुभव",
    maybeLater: "बाद में",
    bookBtn: "अपॉइंटमेंट बुक करें",
  },
  te: {
    title: "అపాయింట్మెంట్ బుక్ చేయండి",
    subtitle: "మహిళా ఆరోగ్య నిపుణుడితో మాట్లాడాలనుకుంటున్నారా?",
    typeLabel: "విజిట్ మోడ్‌ను ఎంచుకోండి",
    online: "ఆన్‌లైన్",
    inPerson: "నేరుగా",
    dateLabel: "ప్రాధాన్య తేదీ",
    timeLabel: "ప్రాధాన్య సమయం",
    langLabel: "భాషా ప్రాధాన్యత",
    doctorTitle: "డాక్టర్",
    doctorName: "Dr. Neha Sharma",
    doctorRole: "మహిళా ఆరోగ్య నిపుణుడు",
    doctorExp: "15+ సంవత్సరాల అనుభవం",
    maybeLater: "తర్వాత",
    bookBtn: "అపాయింట్మెంట్ బుక్ చేయండి",
  },
};

export default function BookAppointmentScreen({ lang = "en", patientData = {}, onBook, onMaybeLater,onBack }) {
  const c = COPY[lang] || COPY.en;
  const [apptType, setApptType] = useState("online");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [apptLang, setApptLang] = useState(lang);

  const canBook = date && time;

  function handleBook() {
    onBook({ apptType, date, time, apptLang, ...patientData });
  }
  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} ${ampm}`;
  };
  const toMinutes = (timeStr) => {
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;

    return hours * 60 + minutes;
  };
  const isToday = (date) => {
    const today = new Date().toISOString().split("T")[0];
    return date === today;
  };
  const nowMinutes = toMinutes(getCurrentTime());

  const availableSlots = TIME_SLOTS.filter((slot) => {
    if (!isToday(date)) return true; // future date → show all

    return toMinutes(slot) > nowMinutes; // today → hide past slots
  });
  return (
    <div className={styles.bookingFormScreen}>
      {/* Header icon */}
      <button className={styles.selectCareBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.bookingIconCircle}>
        <CalendarIcon size={30} />
      </div>
      <div className={styles.bookingFormTitle}>{c.title}</div>
      <div className={styles.bookingFormSub}>{c.subtitle}</div>

      {/* Appointment Type */}
      {/* <div className={styles.bookingSection}>
        <div className={styles.bookingSectionLabel}>{c.typeLabel}</div>
        <div className={styles.apptTypeRow}>
          <button
            className={apptType === "online" ? styles.apptTypeCardActive : styles.apptTypeCard}
            onClick={() => setApptType("online")}
          >
            <VideoIcon size={18} />
            <span>{c.online}</span>
          </button>
          <button
            className={apptType === "inperson" ? styles.apptTypeCardActive : styles.apptTypeCard}
            onClick={() => setApptType("inperson")}
          >
            <LocationIcon size={18} />
            <span>{c.inPerson}</span>
          </button>
        </div>
      </div> */}

      {/* Preferred Date */}
      <div className={styles.bookingSection}>
        <div className={styles.bookingSectionLabel}>{c.dateLabel}</div>
        <input
          type="date"
          className={styles.bookingDateInput}
          value={date}
          min={new Date().toISOString().split("T")[0]}
          onChange={(e) => setDate(e.target.value)}
          placeholder="dd-mm-yyyy"
          max="2099-12-31"
        />
      </div>

      {/* Preferred Time */}
      <div className={styles.bookingSection}>
        <div className={styles.bookingSectionLabel}>{c.timeLabel}</div>
        <div className={styles.timeGrid}>
          {/* {TIME_SLOTS.map((slot) => (
            <button
              key={slot}
              className={time === slot ? styles.timeSlotActive : styles.timeSlot}
              onClick={() => setTime(slot)}
            >
              {slot}
            </button>
          ))} */}
          {TIME_SLOTS.map((slot) => {
            const disableSlot = isToday(date) && isPastSlot(slot);

            return (
              <button
                key={slot}
                disabled={disableSlot}
                className={
                  disableSlot
                    ? styles.timeSlotDisabled
                    : time === slot
                      ? styles.timeSlotActive
                      : styles.timeSlot
                }
                // className="text-xs font-medium transition-all"
                style={{
                  backgroundColor:disableSlot&&'#f3f4f6',
                  border: disableSlot && '1.5px solid #e5e7eb',

                }}
                onClick={() => !disableSlot && setTime(slot)}
              >
                {slot}
              </button>
            );
          })}

        </div>
      </div>

      {/* Language Preference */}
      <div className={styles.bookingSection}>
        <div className={styles.bookingSectionLabel}>{c.langLabel}</div>
        <div className={styles.langPrefRow}>
          {LANGS_OPTIONS.map(({ code, label }) => (
            <button
              key={code}
              className={apptLang === code ? styles.langPrefBtnActive : styles.langPrefBtn}
              onClick={() => setApptLang(code)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Doctor Card */}
      <div className={styles.doctorCard}>
        <div className={styles.doctorAvatar}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e86f00" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div className={styles.doctorInfo}>
          <div className={styles.doctorName}>{c.doctorName}</div>
          <div className={styles.doctorRole}>{c.doctorRole}</div>
          <div className={styles.doctorExp}>{c.doctorExp}</div>
        </div>
      </div>

      {/* Actions */}
      <div className={styles.bookingActions}>
        <button className={styles.bookingBackBtn} onClick={onMaybeLater}>
          {c.maybeLater}
        </button>
        <button
          className={canBook ? styles.bookingContinueBtn : styles.bookingContinueBtnDisabled}
          disabled={!canBook}
          onClick={handleBook}
        >
          {c.bookBtn}
        </button>
      </div>
    </div>
  );
}
